import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_SEARCH_REPLACE } from '@editor/src/img/pageIndex';
import { getPlatformShortcut } from '@src/js/utils';

export const config = {
    id: ActionType.SEARCH_REPLACE,
    content: i18n.t('查找'),
    tipMsg: i18n.t('查找和替换'),
    icon: TOOLBAR_SEARCH_REPLACE,
    shortcut: {
        win: 'Ctrl+F',
        mac: '⌘+F',
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
        shortcut: config.shortcut,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.SEARCH_REPLACE,
        content: i18n.t<string>('查找与替换'),
        description: getPlatformShortcut('Cmd+F'),
    },
];
